export const addressDataTransformer = (address: any) => {
  if (!address) return {};
  return {
    addressId: address.address_id,
    attributeSetId: address.attribute_set_id,
    city: address.city,
    countryId: address.country_id,
    createdAt: address.created_at,
    customerAddressId: address.customer_address_id,
    entityId: address.entity_id,
    entityTypeId: address.entity_type_id,
    firstName: address.firstname,
    incrementId: address.increment_id,
    isActive: address.is_active,
    isSetDefault: address.is_set_default,
    lastName: address.lastname,
    parentId: address.parent_id,
    postcode: address.postcode,
    region: address.region,
    regionId: address.region_id,
    street: address.street,
    phone: address.telephone,
    updatedAt: address.updated_at,
    email: address.email,
    isdCode: address.isd_code,
  };
};
export const addressDataTransformerFashion = (address: any) => {
  if (!address) return {};
  return {
    addressId: address.addressId,
    city: address.city,
    countryId: address.countryId,
    customerAddressId: address.addressId,
    firstName: address.fullName,
    isSetDefault: address.isDefault,
    postcode: address.pincode,
    region: address.state,
    regionId: address.regionId,
    house:address.addressLineOne,
    area:address.addressLineTwo,
    street: address.addressLineOne + " " + address.addressLineTwo,
    phone: address.mobileNumber,
    email: address.email,
    country:address.country,
    regionCode:address.regionCode,
  };
};


export const importAddressDataTransformerFashion = (address: any) => {
  if (!address) return {};
  return {
    addressId: address.addressId,
    city: address.city,
    countryId: address.countryId,
    customerAddressId: address.addressId,
    firstName: address.fullName,
    isSetDefault: address.isDefault,
    postcode: address.pincode,
    region: address.state,
    regionId: address.regionId,
    house:address.addressLineOne,
    area:address.addressLineTwo,
    street: address.addressLineOne + " " + (address.addressLineTwo ? address.addressLineTwo : ""),
    phone: address.mobileNumber,
    email: address.email,
    country:address.country,
    regionCode:address.regionCode,
    isChecked: true,
  };
};
